module.exports = __webpack_public_path__ + "img/public/SiteIcons/popularNextArrow.svg?edff3941";